import debounce from 'lodash/debounce';

/**
 * Reports syncing as soon as an edit is waiting to reach collab: Finish signing is gated on it,
 * and the server only waits for saves collab has already received. Reporting synced is
 * debounced so the saving indicator doesn't flicker between keystrokes.
 */
export function createUnsyncedChangesHandler(setSyncing: (isSyncing: boolean) => void) {
  const settle = debounce(() => setSyncing(false), 1000);

  return ({ number }: { number: number }) => {
    if (number > 0) {
      settle.cancel();
      setSyncing(true);
    } else settle();
  };
}
